export const iconButtonCustomizations = {
  MuiIconButton: {
    styleOverrides: {
      root: {
        color: "black", // icon color
        border: "none",
        backgroundColor: "transparent",
        borderRadius: 8,
        padding: 6,
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 0.1)", // subtle white hover
        },
      },
    },
  },
};
